import { GetConferenceWaitingRoom } from 'domain/usecases/conferenceWaitingRoom/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGetConferenceWaitingRoom
  implements GetConferenceWaitingRoom
{
  private readonly url: string;

  private readonly httpClient: HttpClient<GetConferenceWaitingRoom.Model>;

  constructor(
    url: string,
    httClient: HttpClient<GetConferenceWaitingRoom.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: GetConferenceWaitingRoom.Params,
  ): Promise<GetConferenceWaitingRoom.Model> => {
    let query = '';
    if (params.query) {
      query = '?';

      Object.entries(params.query).forEach(([key, value]) => {
        if (value) query += `${key}=${value}&`;
      });
    }

    const httpResponse = await this.httpClient.request({
      url: `${this.url.replace(
        '{conferenceShort}',
        params.conferenceShort,
      )}${query}`,
      method: 'get',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
